module.exports = __webpack_public_path__ + "img/chord_title.dbb72b32.png";